import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, DatePicker, Menu, Dropdown, Badge } from 'antd'
import { useHistory } from 'react-router-dom'

import { useListData, usePet, useToggle } from '../../modules'

import { clearOrder } from '../../store/actions'

import { SaleItem } from './newBill'

import Order from './order'
import Variants from './variants'
// import OrderVariants from '../modals/ordervariants'
import Receive from '../resusable/receive'

const { RangePicker } = DatePicker

const AddToBill = ({ onComplete }) => {
    const [item, setItem] = useState(null)
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState(null)
    const [string, setString] = useState('')

    const { id } = useParams()

    const dispatch = useDispatch()

    const history = useHistory()

    useEffect(() => {
        return () => {
            dispatch(clearOrder())
        }
    }, [])

    const [orderVisible, toggleOrderVisible] = useToggle()
    const [variantsModal, toggleVariantsModal] = useToggle()

    const { order } = useSelector(state => state.order)

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems },
        { list: saleItems },
        { Paginate }
    ] = useListData('pointOfSaleItems', {
        category: category?.label,
        string,
    }, { notify: true }, 'items')

    const [,{ list: tables }] = useListData('tables', {}, { notify: true }, 'tables', 1000)

    const [, getCats] = usePet('saleItemCategories', {}, { notify: true, callback: ({ data }) => setCategories(data) })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            fetchItems()
    }

    const selectItem = itm => {
        setItem(itm)
        toggleVariantsModal()
    }

    const selectCategory = cat => {
        setCategory(cat)
        fetchItems()
    }

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => history.push('/app/bills'), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            className="bg-gray-100"
            footer={
                <div className="w-full text-right">
                    {
                        order?.length > 0 ?
                            <Badge count={ order?.length }>
                                <button onClick={ toggleOrderVisible } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Complete</button>
                            </Badge>
                        : null
                    }
                    <button onClick={close} className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="100%">
            <p className="font-extrabold text-3xl mb-0">Add to Bill</p>
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                <div className="flex justify-center items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-name"
                        type="text"
                        placeholder="Type to search items" />
                </div>
                {/* {
                    item &&
                    <OrderVariants
                        item={item}
                        visible={variantsModal}
                        toggle={toggleVariantsModal} />
                } */}
                {
                    item &&
                    <Variants
                        item={item}
                        visible={variantsModal}
                        toggle={toggleVariantsModal} />
                }
                <Order
                    bill={id}
                    tables={ tables }
                    visible={orderVisible}
                    onPerform={ onComplete }
                    toggle={toggleOrderVisible} />
                <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                        <h2 className="font-semibold text-gray-800">Items in stock</h2>
                        <Select
                            isClearable
                            value={category}
                            onChange={selectCategory}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={categories.map(cat => ({ label: cat, value: cat }))}
                            placeholder="Select Category" />
                    </header>
                    <Receive
                        loading={itemsLoading}
                        error={itemsError}>
                        <div className="grid grid-cols-2 pb-7 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 mt-4 gap-x-4 gap-y-4 p-3 shadow-md hover:shodow-lg">
                            {
                                saleItems.map((item, key) =>
                                    <SaleItem
                                        i={key}
                                        item={ item }
                                        selectItem={selectItem}
                                        order={order} />)
                            }
                        </div>
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </Drawer>
    )
}

export default AddToBill